"use client";

import { useEffect } from "react";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: Record<string, unknown>[];
  }
}

export function trackEvent(event: string, params?: Record<string, unknown>) {
  window.dataLayer?.push({ event, ...params });
}

export function trackCTA(ctaName: string, location: string) {
  trackEvent("cta_click", { cta_name: ctaName, cta_location: location });
}

export function trackFaqToggle(question: string) {
  trackEvent("faq_toggle", { faq_question: question });
}

// CTA click tracking
export function trackCTAClick(ctaName: string, ctaLocation: string) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "cta_click", {
      cta_name: ctaName,
      cta_location: ctaLocation,
      page_path: window.location.pathname,
    });
  }
}

// Sector page view tracking
export function trackSectorView(sectorName: string) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "sector_page_view", {
      sector_name: sectorName,
    });
  }
}

// Comparison page view tracking
export function trackComparisonView(comparisonType: string) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "comparison_view", {
      comparison_type: comparisonType,
    });
  }
}

// Video play tracking
export function trackVideoPlay(videoTitle: string) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "video_play", {
      video_title: videoTitle,
    });
  }
}

export function ScrollDepthTracker() {
  useEffect(() => {
    const thresholds = [25, 50, 75, 90];
    const fired = new Set<number>();

    function onScroll() {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      const percent = Math.round((scrollTop / docHeight) * 100);

      for (const t of thresholds) {
        if (percent >= t && !fired.has(t)) {
          fired.add(t);
          trackEvent("scroll_depth", { percent_scrolled: t });
        }
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return null;
}
